import React from "react";
import js from "../data/icons/js.svg";
import Git from "../data/icons/git.svg";
import Firebase from "../data/icons/firebase.svg";
import Reactt from "../data/icons/react.svg";
import redux from "../data/icons/redux.svg";
import Tailwind from "../data/icons/tailwind.svg";
import MongoDB from "../data/icons/mongodb-icon.svg";

const Skills = () => {
  const skillsArray = [
    [js, "JavaScript"],
    [Reactt, "React"],
    [redux, "Redux"],
    [Firebase, "Firebase"],
    [MongoDB, "MongoDB"],
    [Tailwind, "Tailwind"],
    [Git, "Git"],
  ];
  return (
    <section className="section dark:text-white" id="skills">
      <h1 className="title">skills</h1>
      <div className="flex justify-around  flex-wrap  gap-2  ph:text-xs ">
        {skillsArray.map((elm, i) => (
          <div
            className="flex flex-col items-center w-[88px] h-[104px] ph:w-[66px] ph:h-[56px]"
            key={i}
          >
            <img
              loading="lazy"
              src={elm[0]}
              alt={elm[1]}
              className="w-20 h-20 ph:w-10 ph:h-10 hover:animate-wiggle "
            />
            <span>{elm[1]}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
